import React from "react";
import classNames from "classnames";
import "./Forms.scss";

interface FormRow {
    columns?: number; //default 3
    contentNumber?: number;
    className?: string;
    type?: 'emtpl' | 'travel'
}

export const FormRow: React.FC<FormRow> = ({type, children, columns, contentNumber, className}) => {
    const classes = classNames(className, {
        "form__row": true,
        "form__row_1": columns === 1,
        "form__row_2": columns === 2,
        "form__row_4": columns === 4
    });

    const classesTravel = classNames(className, {
        "form__row-travel": true,
        "form__row-travel_1": columns === 1,
        "form__row-travel_2": columns === 2,
        "form__row-travel_4": columns === 4,
        "form__row-travel_3-centered": columns === 3 && contentNumber % columns > 0,
    });

    return (
        <div className={type === 'travel' ? classesTravel : classes}>
            {children}
        </div>
    )
};